module.exports = __webpack_public_path__ + "media/metronic/_theme/media/demos/demo9/bg-400-184b5538bd355d6dac79bdf8a6331a6c.jpg";